import { createFileRoute, redirect } from "@tanstack/react-router";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/audi-second-hand-romania/")({
  head: () => routeHead("/audi-second-hand-romania/"),
  beforeLoad: () => {
    throw redirect({ href: "/cars/audi", statusCode: 301, replace: true });
  },
});
